import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoArrowForward } from "react-icons/io5";

const UnsubscribePage = () => {
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Add API call or logic for unsubscribing here
    // Example:
    // unsubscribeUser({ email, reason: selectedReason, otherReason });
    toast.success("You have unsubscribed successfully.");
    // Clear all fields after submission
    setEmail("");
    setSelectedReason("");
    setOtherReason("");

  };

  return (
    <>
      <div className="about-us-page">
        <Header />
      </div>

      <div className="px-6 lg:px-8 lg:pb-14 pt-28 pb-10 max-w-7xl m-auto">
        <h1 className="text-2xl font-semibold mb-2 text-gray-800">
        YOU'LL MISS OUR EXCITING OFFERS & NEWSLETTER
        </h1>
        <p className="text-gray-600 text-sm mb-6">
          Please take a moment to tell us why you no longer want to hear from us
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Reason Options */}
          <div className="flex items-center">
            <input
              id="reason1"
              type="radio"
              name="reason"
              value="no-longer-want"
              checked={selectedReason === "no-longer-want"}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <label htmlFor="reason1" className="ml-2 text-gray-700 cursor-pointer">
              I no longer want to receive these emails
            </label>
          </div>

          <div className="flex items-center">
            <input
              id="reason2"
              type="radio"
              name="reason"
              value="never-signed-up"
              checked={selectedReason === "never-signed-up"}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <label htmlFor="reason2" className="ml-2 text-gray-700 cursor-pointer">
              I never signed up for this mailing list
            </label>
          </div>

          <div className="flex items-center">
            <input
              id="reason3"
              type="radio"
              name="reason"
              value="inappropriate"
              checked={selectedReason === "inappropriate"}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <label htmlFor="reason3" className="ml-2 text-gray-700 cursor-pointer">
              The emails are inappropriate
            </label>
          </div>

          <div className="flex items-center">
            <input
              id="reason4"
              type="radio"
              name="reason"
              value="spam"
              checked={selectedReason === "spam"}
              onChange={(e) => setSelectedReason(e.target.value)}
              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <label htmlFor="reason4" className="ml-2 text-gray-700 cursor-pointer">
              The emails are spam and should be reported
            </label>
          </div>

          <div>
            <div className="flex items-center">
              <input
                id="reason5"
                type="radio"
                name="reason"
                value="other"
                checked={selectedReason === "other"}
                onChange={(e) => setSelectedReason(e.target.value)}
                className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <label htmlFor="reason5" className="ml-2 text-gray-700 cursor-pointer">
                Other
              </label>
            </div>
            {selectedReason === "other" && (
              <textarea
                className="mt-4 w-[650px] p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                rows="3"
                placeholder="Please tell us your reason"
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
              />
            )}
          </div>

          {/* Email Input Field placed below the radio options */}
          <div className="flex">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="md:w-[400px] w-full py-2 px-4 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
              required
            />
            {/* Unsubscribe Button */}
          <button
            type="submit"
            className="px-8 flex items-center bg-gray-800 text-white py-2 rounded-r-lg hover:bg-gray-950 transition duration-200"
          >
            Unsubscribe <IoArrowForward className="ml-2 text-lg" />
          </button>
          </div>          
        </form>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default UnsubscribePage;
